export default function FamilyBalanceItem(id, familyId, level) {
  this.id = id;
  this.familyId = familyId;
  this.level = level;
  this.childIndex = 0;
}